import { SUPPORT_STAFF_REPLY } from "./actions";

const initialState = {
  reply: {
    docs: [],
    totalDocs: 0,
    limit: 0,
    page: 0,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  replyLoading: true,
};

const replyReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SUPPORT_STAFF_REPLY:
      return {
        ...state,
        reply: payload,
        replyLoading: false,
      };
    default:
      return state;
  }
};

export default replyReducer;
